import React, { useEffect, useState } from 'react';

import { Divider, Spinner } from '@telus-uds/components-web';

import { TopBarWrapper } from './css';

import request from '../../../utils/request';

import Add from './components/add';
import Filter from './components/filter';
import Block from './components/block';

const Dealership = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState('');

  const fetchData = async () => {
    try {
      const result = await request.get('/dealerships');

      if (result && result.status === 200) {
        setApiData(result.data.rows);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <>
          <TopBarWrapper>
            <Add fetchData={fetchData} />
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarWrapper>
          <Divider space={3} variant={{ inverse: true }} />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
    </>
  );
};

export default Dealership;
